<template>
  <section class="faq-section">

    <div class="container">

      <div class="header">

        <h1>
          Foire Aux Questions
        </h1>

        <p>
          Retrouvez les réponses aux questions les plus fréquentes
          concernant HayMiutyun et notre communauté d'entraide arménienne.
        </p>

      </div>


      <div class="faq-list">

        <div
          v-for="(item,index) in faq"
          :key="index"
          class="faq-item"
          :class="{active:activeIndex===index}"
        >

          <button
            class="question"
            @click="toggle(index)"
          >

            <span>
              {{ item.question }}
            </span>

            <span class="icon">
              {{ activeIndex===index ? "−" : "+" }}
            </span>

          </button>


          <transition name="slide">

            <div
              v-if="activeIndex===index"
              class="answer"
            >
              {{ item.answer }}
            </div>

          </transition>


        </div>

      </div>



      <div class="contact-box">

        <div class="contact-icon">
          ?
        </div>

        <h2>
          Une question
        </h2>

        <p>
          Notre équipe vous répondra rapidement.
        </p>


        <input
          v-model="contact.name"
          placeholder="Votre nom"
        />


        <input
          v-model="contact.email"
          type="email"
          placeholder="Votre email"
        />


        <textarea
          v-model="contact.message"
          placeholder="Votre question..."
        />


        <button
          @click="sendMessage"
        >
          Envoyer ma question
        </button>


      </div>


    </div>

  </section>
</template>


<script setup>

import { ref } from "vue";

const activeIndex = ref(null);

const faq = [

{
question:
"Qu’est-ce que HayMiutyun ?",

answer:
"HayMiutyun est une plateforme d’entraide qui rassemble la communauté arménienne afin de connecter les personnes ayant besoin de soutien avec celles qui souhaitent aider."
},


{
question:
"Pourquoi avoir créé HayMiutyun ?",

answer:
"HayMiutyun a été créé par deux jeunes Arméniens avec la volonté de construire une communauté solidaire où chacun peut partager son aide, ses compétences et ses opportunités."
},


{
question:
"Qui peut rejoindre HayMiutyun ?",

answer:
"Tout le monde peut rejoindre HayMiutyun. Que vous souhaitiez demander de l’aide, proposer votre aide ou simplement participer à la communauté, vous êtes les bienvenus."
},


{
question:
"Quels types d’aide peut-on demander ?",

answer:
"Vous pouvez demander différents types d’aide : recherche de logement, emploi, accompagnement administratif, conseils, mise en relation ou toute autre forme de soutien communautaire."
},


{
question:
"Comment puis-je proposer mon aide ?",

answer:
"Vous pourrez prochainement rejoindre notre réseau d’entraide afin de proposer vos compétences, votre temps ou vos ressources aux membres de la communauté."
},


{
question:
"HayMiutyun est-il une association ?",

answer:
"HayMiutyun est actuellement un projet communautaire lancé par deux jeunes Arméniens avec l’objectif de construire une grande plateforme d’entraide. De nombreux projets sont en préparation."
},


{
question:
"Quels sont les futurs projets de HayMiutyun ?",

answer:
"Nous préparons plusieurs initiatives pour développer la communauté : nouveaux services, événements solidaires, collaborations et outils permettant de faciliter l’entraide entre Arméniens."
}

];

function toggle(index){

 activeIndex.value =
 activeIndex.value === index
 ? null
 : index;

}

import API_URL from "@/config/api"

const contact = ref({

name:"",
email:"",
message:""

})

const sendMessage = async()=>{

await fetch(

`${API_URL}/api/ContactMessages`,

{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:
JSON.stringify(contact.value)
}

)

alert(
"Merci ! Votre message a bien été envoyé."
)

contact.value={
name:"",
email:"",
message:""
}

}

</script>


<style scoped>

*{
  box-sizing:border-box
}

.faq-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc)
}

.container{
  max-width:1000px;
  width:100%;
  margin:auto
}


.header{
  text-align:center;
  margin-bottom:50px
}


.header h1{
  font-size:48px;
  font-weight:800;
  margin:0 0 15px;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}


.header p{
  max-width:700px;
  margin:auto;
  font-size:18px;
  color:#666;
  line-height:1.8
}



.faq-list{
  display:flex;
  flex-direction:column;
  gap:15px
}


.faq-item{
  background:white;
  border-radius:22px;
  box-shadow:0 10px 30px rgba(0,0,0,.06);
  overflow:hidden;
  transition:.3s;
  border-left:5px solid transparent
}


.faq-item.active{
  border-color:#D90012
}


.question{
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:22px 25px;
  border:none;
  background:none;
  cursor:pointer;
  font-size:18px;
  font-weight:600;
  color:#222;
  text-align:left
}


.icon{
  width:35px;
  height:35px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff1f2;
  color:#D90012;
  font-size:25px;
  font-weight:bold;
  flex-shrink:0
}


.answer{
  padding:0 25px 25px;
  color:#666;
  line-height:1.8;
  font-size:16px
}


.slide-enter-active,
.slide-leave-active{
  transition:.3s ease
}


.slide-enter-from,
.slide-leave-to{
  opacity:0;
  transform:translateY(-10px)
}



.contact-box{
  margin:60px auto 0;
  max-width:700px;
  background:white;
  padding:40px;
  border-radius:30px;
  text-align:center;
  box-shadow:0 20px 50px rgba(0,0,0,.08);
  border-top:5px solid #D90012
}


.contact-icon{
  width:60px;
  height:60px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:28px;
  font-weight:bold
}


.contact-box h2{
  font-size:32px;
  margin:0 0 10px
}


.contact-box p{
  color:#666;
  margin-bottom:25px
}


.contact-box input,
.contact-box textarea{

  width:100%;
  padding:15px 18px;
  margin-top:15px;
  border-radius:15px;
  border:1px solid #ddd;
  font-size:16px;
  font-family:inherit;
  outline:none;
  transition:.3s
}


.contact-box input:focus,
.contact-box textarea:focus{
  border-color:#D90012;
  box-shadow:0 0 0 3px rgba(217,0,18,.1)
}


.contact-box textarea{
  height:150px;
  resize:none
}


.contact-box button{
  width:100%;
  margin-top:20px;
  padding:16px;
  border:none;
  border-radius:30px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:17px;
  font-weight:700;
  cursor:pointer;
  transition:.3s
}


.contact-box button:hover{
  transform:translateY(-3px);
  box-shadow:0 10px 25px rgba(217,0,18,.25)
}



@media(max-width:700px){

  .faq-section{
    padding:25px 15px
  }


  .header h1{
    font-size:32px
  }


  .question{
    padding:18px;
    font-size:16px
  }


  .answer{
    padding:0 18px 20px
  }


  .contact-box{
    padding:25px 20px
  }


  .contact-box h2{
    font-size:26px
  }

}

</style>